import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as Template from "../../templates";
import * as actions from "../../actions";

import EditorField from "../../templates/modules/forms/Editor";
import { useNavigate, useParams } from "react-router-dom";

export default () => {
  const moduleName = "brands";
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const params = useParams()
  const navigate = useNavigate()
  const [id, setId] = useState();
  
  const [about, setAbout] = useState(``);
  const [state, setState] = useState(``);
  const [link, setLink] = useState(``);
  const [name, setName] = useState(``);
  const [slug, setSlug] = useState(``);
  const [logo, setLogo] = useState(``);
  const [banner, setBanner] = useState(``);
  const [certification, setCertification] = useState(``);
  const [national, setNational] = useState(``);
  const [submitted, setSubmitted] = useState(false);

  const [metaDescription, setMetaDescription] = useState(``);
  const [metaKeywords, setMetaKeywords] = useState(``);
  const [metaTitle, setMetaTtitle] = useState(``);

  const handleChangeNational = (value) => setNational(value);
  const handleChangeState = (value) => setState(value);
  const handleAboutChange = (value) => setAbout(value);
  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.brands_store != undefined && appReducer.brands_store.error == false) ||
        (appReducer.brands_update != undefined && appReducer.brands_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.brands_store,
    appReducer.brands_update
  ])

  useEffect(() => {
    if (appReducer.brands_edit != undefined && id != undefined) {
      let row = appReducer.brands_edit.data;
      if (row) {
        setName(row.name);
        setSlug(row.slug);
        setLink(row.link);
        setNational({
          value: row.national,
          label: row.national == `ir` ? `داخلی` : `خارجی`,
        });
        setBanner(row.banner_full);
        setCertification(row.certification_full);
        setLogo(row.logo_full);
        setMetaKeywords(row.meta_keywords)
        setMetaDescription(row.meta_description)
        setMetaTtitle(row.meta_title)
        setAbout(row.about);
        setState({
          value: row.state,
          label: row.state == `active` ? `فعال` : `غیرفعال`,
        });
      }
    }
  }, [appReducer.brands_edit]);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  return <Template.Form>
    <Template.Input required value={name} label="نام" name="name" type="text" />
    <Template.Input required value={slug} label="نام (لاتین)" name="slug" type="text" />
    <Template.Input value={link} className="ltr" label="وب سایت" name="link" type="text" />
    <Template.FileInput
      deleteUrl="brands/destroy_image"
      rowId={id}
      required
      className="logo"
      value={logo && [logo]}
      name="logo"
      label="لوگو"
    />
    <Template.FileInput
      deleteUrl="brands/destroy_banner"
      className="banner"
      rowId={id}
      value={banner && [banner]}
      name="banner"
      label="بنر"
    />
    <Template.FileInput
      className="certification"
      deleteUrl="brands/destroy_certification"
      rowId={id}
      value={certification && [certification]}
      name="certification"
      label="گواهی ثبت"
    />
    <Template.SingleSelect
      withLabel
      placeholder="نوع"
      onChange={handleChangeNational}
      name="national"
      value={national}
      options={[
        {
          value: "ir",
          label: "داخلی",
        },
        {
          value: "nl",
          label: "خارجی",
        },
      ]}
    />
    <div>
      <EditorField
        label="توضیحات"
        onEditorChange={handleAboutChange}
        value={about}
      />
      <input name="about" type="hidden" defaultValue={about} />
    </div>
    <Template.SingleSelect
      withLabel
      required
      placeholder="وضعیت"
      onChange={handleChangeState}
      name="state"
      value={state}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />

    <Template.Seo
    keywords={metaKeywords}
    description={metaDescription}
    title={metaTitle}
  />


    <Template.Button
      label="ذخیره"
      
      onClick={handleClick}
    />
  </Template.Form>;
};
